import axios, { AxiosResponse } from 'axios';

export interface IisinZmena {
    idzadosti: number;
    datumzmeny: string;
}

interface subj {
    subj: IisinZmena[];
}

interface c2 {
    c2: subj;
}

export interface isin {
    isin: c2;
}
interface IZadostPostResp {
    datumzmeny: string;
    idzadosti: number;
}

const isinZmenaApi = (idzadosti: number) => {
    return axios({
        method: 'GET',
        url: `ZadostoZmenaISIN/${idzadosti}/`
    }).then((resp: AxiosResponse<isin>) => resp.data.isin.c2.subj);
};

export const isinZmenaPost = (idmb: number, stat: string, typZadosti: 'Zruseni' | 'Zmena') => {
    return axios({
        method: 'POST',
        url: `Zadosto${typZadosti}ISIN`,
        data: {
            idmb: idmb,
            stat: stat
        }
    }).then((resp: AxiosResponse<IZadostPostResp>) => resp.data);
};

export default isinZmenaApi;
